import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: 'report',
    loadComponent: () => import('./powerbi-report/powerbi-report').then((c) => c.PowerbiReport),
    canActivate: [MsalGuard],
  },
  {
    path: 'sso-auth',
    redirectTo: 'report',
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'report',
    pathMatch: 'full',
  },
];
